import { useUser } from '#hooks';

import { Head, LoadingContent } from '#components';
import { HeadUnderlineVariant } from '#components.types';

import Form from './containers/Form';

export default () => {
  const [data, { generalLoading }] = useUser();

  if (generalLoading || !data) {
    return <LoadingContent />;
  }

  return (
    <>
      <Head
        {...{
          label: 'Редактирование пользователя',
          underlineVariant: HeadUnderlineVariant.Secondary,
        }}
      />
      <Form {...{ data }} />
    </>
  );
};
